export default __webpack_public_path__ + "static/config-2023-themework-header-dcf72827cc1966f56f40596411a2229c6d7a88bb90a21770fdc0f280a782b7b4.png";